<script setup>
import {useCart} from "@/stores/cart";
import down from "@i/down-white.svg";
import {ref} from "vue";
import {useI18n} from "vue-i18n";

const cart = useCart();
const {n} = useI18n();

const showProducts = ref(false)

defineProps({
    shippingRate: {
        type: Object,
    },
    form: {
        type: Object,
    },
})

function centsToMoney(cents) {

    if (cents == null || isNaN(cents)) {
        return '';
    }

    return n(cents / 100, "currency").replace("€", "EUR");
}
</script>
<template>
    <div>
        <div class="prose flex flex-col bg-grey-dark px-4 py-8 text-white lg:w-120 lg:p-8">
            <h2 class="uppercase text-white">
                {{ $t("Checkout") }}
            </h2>

            <div
                class="grid cursor-pointer select-none grid-cols-3 p-0"
                @click="showProducts = !showProducts"
            >
                <div class="col-span-2 flex flex-nowrap items-center">
                    <div class="whitespace-nowrap">
                        {{ $t("Totaal products ({number})", {number: cart.cartCount}) }}
                    </div>

                    <img
                        :src="down"
                        class="my-0 ml-4 inline-block size-4 transition-transform duration-200"
                        :class="{ 'rotate-180': showProducts }"
                        :alt="$t('Show products')"
                    >
                </div>
                <div class="text-right">
                    {{ centsToMoney(cart.product_display_total) }}
                </div>
            </div>
            <div v-if="showProducts">
                <div
                    v-for="product in cart.productVariants"
                    :key="product.id"
                    class="grid grid-cols-3"
                >
                    <div class="col-span-2">
                        {{ product.title }} ({{ product.quantity }})
                    </div>
                    <div class="text-right">
                        {{ centsToMoney(product.current_display_price * product.quantity) }}
                    </div>
                </div>
            </div>

            <div class="mt-4 grid grid-cols-2">
                <div>{{ $t("Shipping cost") }}</div>
                <div class="text-right">
                    {{ centsToMoney(shippingRate?.display_price) }}
                </div>
            </div>
            <hr class="my-4">
            <div class="grid grid-cols-2">
                <div
                    v-if="cart.discount_including_vat > 0"
                    class="font-bold"
                >
                    {{ $t("Total saving") }}
                </div>
                <div
                    v-if="cart.discount_including_vat > 0"
                    class="text-right font-bold"
                >
                    {{ centsToMoney(cart.discount_including_vat) }}
                </div>
                <div class="font-bold">
                    {{ $t("Total") }}
                </div>
                <div class="text-right font-bold">
                    {{ centsToMoney(cart.total_including_vat) }}
                </div>
            </div>

            <div class="my-8 flex" />

            <slot />
        </div>
    </div>
</template>
